import './nav-bar.scss';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

/*
 * Component responsible for <nav-bar> component.
 */
angular.module('posApp').component('navBar', {
  template: require('./nav-bar.html').default,

  bindings: {
    swDisabled: '=',
    onClick: '&',
  },

  controller: function (
    isFiscalReturn,
    navigateTo: NavigateTo,
    pos,
    settingsManager: SettingsManager,
  ) {
    const $ctrl = this;

    // Expose pos service to template
    $ctrl.pos = pos;

    $ctrl.isFiscalReturn = isFiscalReturn;

    $ctrl.$onInit = () => {
      $ctrl.getClass(pos.selectedMenu);
    };

    $ctrl.getClass = (ind) => {
      if (ind == pos.selectedMenu) {
        return 'ui-btn-active';
      } else {
        return '';
      }
    };

    $ctrl.goTo = (route, id) => {
      console.log('onClick', $ctrl.onClick);

      if (angular.isFunction($ctrl.onClick)) {
        $ctrl.onClick();
      }

      pos.selectedMenu = id;

      navigateTo(route);
    };

    $ctrl.showCustomer = () => {
      return !settingsManager.settings.pos?.hideCustomer;
    };
  },
});
